import { Routes } from '@angular/router';
import { BaseViewComponent } from '@base-shared/components/base-view/base-view.component';
import { AppComponent } from '@base/app.component';
import { AnonymousGuard } from '@base-guards/anonymous.guard';
import { AuthGuard } from '@base-guards/auth.guard';
import { BillingGuard } from '@base-guards/billing.guard';
import { PermissionsGuard } from '@base-guards/permissions.guard';
var ɵ0 = {
    permission: {
        type: 'account',
        permissions: ['BASE']
    }
}, ɵ1 = {
    permission: {
        type: 'account',
        permissions: ['MANAGE_USERS', 'MANAGE_PROJECTS']
    }
};
var routes = [
    {
        path: '',
        component: AppComponent,
        canActivate: [AnonymousGuard],
        children: [
            {
                path: '',
                loadChildren: '@eyrus/modules/splash/splash.module#EyrusSplashModule',
            },
        ]
    },
    {
        path: 'billing',
        loadChildren: '@eyrus/modules/billing/billing.module#BillingModule',
        canActivate: [AuthGuard],
    },
    {
        path: 'eyrus',
        component: BaseViewComponent,
        children: [
            {
                path: '',
                redirectTo: 'projects',
                pathMatch: 'full'
            },
            {
                path: 'projects',
                loadChildren: '@eyrus/modules/projects/projects.module#GcDashboardModule',
                canActivate: [AuthGuard, BillingGuard],
            },
            {
                path: 'daily-reports',
                loadChildren: '@eyrus/modules/daily-reports/daily-reports.module#DailyReportsModule',
                canActivate: [AuthGuard, BillingGuard],
            },
            {
                path: 'readers',
                loadChildren: '@eyrus/modules/readers/readers.module#ReadersModule',
                canActivate: [AuthGuard, BillingGuard],
            },
            {
                path: 'daily-logs',
                loadChildren: '@eyrus/modules/daily-logs/daily-logs.module#DailyLogsModule'
            },
            {
                path: 'contracts',
                loadChildren: '@eyrus/modules/contracts/contracts.module#ContractsModule',
                canActivate: [AuthGuard, PermissionsGuard, BillingGuard],
                data: ɵ0
            },
            {
                path: 'admin',
                loadChildren: '@eyrus/modules/admin/admin.module#AdminModule',
                canActivate: [AuthGuard, PermissionsGuard, BillingGuard],
                data: ɵ1
            },
            {
                path: 'questionnaire',
                loadChildren: '@eyrus/modules/contracts/reviewer/settings/questionnaire/questionnaire.module#QuestionnaireModule',
                canActivate: [AuthGuard, BillingGuard],
            },
            {
                path: 'profile',
                loadChildren: '@eyrus/modules/settings/profile/profile.module#EyrusProfileModule',
                canActivate: [AuthGuard, BillingGuard],
            },
        ]
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1 };
